import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Churchgatetopunecab() {



const cardData = {
  keyword: " Church Gate to Pune Cab Service ",

headingDescription: "Velocity Cab provides reliable and comfortable Churchgate to Pune cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Churchgate to Pune convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Churchgate to Pune cab travel.",

topPlaces: [
 
  {
    title: "Saras Baug",
    description: "Saras Baug is a popular recreational garden in Pune featuring beautifully maintained lawns and the famous Siddhivinayak Temple. Visitors can relax amidst nature, enjoy leisurely walks, and experience one of the city's favorite family-friendly destinations."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum is home to thousands of rare artifacts, traditional musical instruments, sculptures, and decorative objects representing India's rich cultural heritage. It offers an enriching experience for history and art enthusiasts."
  },
   {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden, also known as Pu La Deshpande Garden, is a beautifully landscaped Japanese-style garden featuring serene ponds, lush greenery, and elegant walking paths. Travelers booking a sedan cab in Pune can enjoy peaceful strolls, scenic photography, and a relaxing escape from the city's busy streets."
  },
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is a magnificent heritage monument associated with India's freedom movement. Visitors can explore its elegant architecture, peaceful gardens, and museum dedicated to Mahatma Gandhi while learning about Pune's historical significance."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut Shiva temple carved from a single basalt rock. Its tranquil surroundings and remarkable architecture make it a popular destination for spirituality, history, and photography."
  },
  {
    title: "Bund Garden",
    description: "Bund Garden is a scenic riverside park offering lush greenery, boating opportunities, and peaceful walking paths. It is a perfect place for families, couples, and nature lovers seeking relaxation."
  },
  {
    title: "Parvati Hill",
    description: "Parvati Hill is one of Pune's oldest landmarks, offering panoramic city views from its historic temple complex. Travelers can climb the stone steps, visit ancient shrines, and enjoy breathtaking scenery."
  },
  {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is Pune's iconic historical fort and a symbol of the Maratha Empire. Visitors can explore its grand gateways, historic ruins, and captivating light and sound show that showcases the city's rich heritage."
  },
  {
    title: "Phoenix Marketcity Pune",
    description: "Phoenix Marketcity Pune is a premier shopping and entertainment destination featuring international brands, restaurants, cinemas, and family-friendly attractions, making it ideal for a day of leisure."
  },
  {
    title: "Khadakwasla Dam",
    description: "Khadakwasla Dam is a scenic getaway on the outskirts of Pune, popular for its peaceful waterfront views, beautiful sunsets, and relaxing atmosphere. It is an excellent destination for picnics and photography."
  }
],



services: [
{
name: "Churchgate to Pune Taxi Fare",
description: "Churchgate to Pune taxi service offers reliable and comfortable intercity travel from South Mumbai to Pune via the Mumbai–Pune Expressway. Travelers can choose from sedan, Ertiga, and Innova Crysta vehicles depending on their comfort and group size. Professional drivers provide punctual pickups from Churchgate station, offices, hotels, and nearby areas like Marine Drive and Nariman Point. This service is widely used by corporate professionals, tourists, and families traveling between Mumbai and Pune. Air-conditioned vehicles and smooth highway driving ensure a relaxed journey. Transparent taxi fare helps travelers plan their travel budget easily with online booking and instant confirmation options."
},
{
name: "Mumbai Central to Pune Cab",
description: "Mumbai Central to Pune cab service provides convenient transportation between Mumbai Central railway station and Pune city. Travelers can book comfortable vehicles such as sedan, Ertiga, and Innova for smooth expressway travel. Professional drivers provide timely pickups and safe driving. This service is ideal for passengers arriving by train and continuing their journey to Pune. Spacious seating and air-conditioned vehicles ensure comfortable long-distance travel."
},
{
name: "CST to Pune Cab Service",
description: "CST to Pune cab service offers dependable transportation from Chhatrapati Shivaji Maharaj Terminus to Pune. Travelers can enjoy comfortable rides in well-maintained vehicles with professional drivers ensuring safe expressway travel. This service is widely used by business travelers, tourists, and families traveling from South Mumbai to Pune."
},
{
name: "Mazdock to Pune Taxi Service",
description: "Mazdock to Pune taxi service provides reliable transportation from Mazgaon Dock area in Mumbai to Pune city. Travelers can book comfortable vehicles with professional drivers ensuring smooth highway travel. This service is ideal for employees, corporate travel, and personal trips."
},
{
name: "Mumbai Central to Pune One Way Cab",
description: "Mumbai Central to Pune one way cab service offers economical travel for passengers requiring single-direction transportation. Travelers only pay for one-way travel, making it a cost-effective option. Comfortable vehicles and professional drivers ensure safe and smooth expressway journeys."
},
{
name: "Nariman Point to Pune Taxi Fare",
description: "Nariman Point to Pune taxi service provides premium transportation from Mumbai’s business district to Pune. Travelers can enjoy comfortable rides in air-conditioned vehicles with professional drivers ensuring safe and timely travel. This route is popular among corporate travelers and executives."
},
{
name: "Gateway of India to Pune Cab",
description: "Gateway of India to Pune cab service offers reliable transportation from one of Mumbai’s most iconic locations to Pune city. Travelers can enjoy smooth expressway travel in comfortable vehicles with professional drivers ensuring safe journeys."
},
{
name: "Worli Mumbai to Pune Cab",
description: "Worli to Pune cab service provides dependable intercity travel between Mumbai and Pune. Travelers can book comfortable vehicles such as sedan, Ertiga, and Innova for smooth highway travel. Professional drivers ensure punctual pickups and safe driving."
},
{
name: "Best Cab Service Mumbai to Pune",
description: "Best cab service Mumbai to Pune offers premium travel experience with well-maintained vehicles, experienced drivers, and reliable service. Travelers can enjoy comfortable journeys with transparent pricing and flexible booking options."
},
{
name: "Mumbai Central to Pune Innova Crysta",
description: "Mumbai Central to Pune Innova Crysta cab service provides luxury SUV travel for passengers seeking comfort and space. The Innova Crysta offers spacious seating and smooth highway performance, making it ideal for long-distance journeys."
},
{
name: "Fort Mumbai to Pune Cab Service",
description: "Fort Mumbai to Pune cab service offers convenient transportation from South Mumbai’s Fort area to Pune city. Travelers can book comfortable vehicles with professional drivers ensuring safe and smooth expressway travel."
},
{
name: "Taxi Service in Churchgate Station to Pune",
description: "Taxi service in Churchgate station to Pune provides easy transportation for passengers traveling directly from railway station to Pune. Professional drivers ensure timely pickups and smooth highway journeys."
},
{
name: "Churchgate to Pimpri Chinchwad Cab Service",
description: "Churchgate to Pimpri Chinchwad cab service offers reliable transportation between South Mumbai and PCMC area of Pune. Travelers can enjoy comfortable rides in well-maintained vehicles with professional drivers ensuring safe travel."
},
{
name: "ChurchGate to Pune Cab",
description: "ChurchGate to Pune cab service offers dependable intercity transportation with comfortable vehicles and professional drivers ensuring safe journeys."
},
{
name: "ChurchGate to Pune Cab Service",
description: "ChurchGate to Pune cab service provides reliable long-distance travel with smooth expressway connectivity and flexible pickup options."
},
{
name: "ChurchGate to Pune Taxi Service",
description: "ChurchGate to Pune taxi service offers convenient travel with experienced drivers and comfortable vehicles ensuring a smooth journey."
},
{
name: "ChurchGate to Pune One Way Cab",
description: "ChurchGate to Pune one way cab service offers economical travel for passengers needing a single-direction trip between Mumbai and Pune."
},
{
name: "ChurchGate to Pune Taxi Fare",
description: "ChurchGate to Pune taxi fare service provides transparent pricing details helping travelers plan their journey budget efficiently."
},
{
name: "ChurchGate to Pune Cab Booking",
description: "ChurchGate to Pune cab booking allows passengers to easily reserve taxis online with instant confirmation and flexible travel schedules."
},
{
name: "Cab from ChurchGate to Pune",
description: "Cab from ChurchGate to Pune offers reliable long-distance transportation with comfortable vehicles and experienced drivers ensuring safe travel."
},
{
name: "ChurchGate to Pune Car Rental",
description: "ChurchGate to Pune car rental service provides flexible travel options with a range of vehicles available for intercity journeys. Travelers can enjoy comfortable and convenient rides with professional drivers."
}
],

tableData: [
["Churchgate to Pune Taxi Fare","Mumbai Central to Pune Cab"],
["CST to Pune Cab Service","Mazdock to Pune Taxi Service"],
["Mumbai Central to Pune One Way Cab","Nariman Point to Pune Taxi Fare"],
["Gateway of India to Pune Cab","Worli Mumbai to Pune Cab"],
["Best Cab Service Mumbai to Pune","Mumbai Central to Pune Innova Crysta"],
["Fort Mumbai to Pune Cab Service","Taxi Service in Churchgate Station to Pune"],
["Churchgate to Pimpri Chinchwad Cab Service","ChurchGate to Pune Cab"],
["ChurchGate to Pune Cab Service","ChurchGate to Pune Taxi Service"],
["ChurchGate to Pune One Way Cab","ChurchGate to Pune Taxi Fare"],
["ChurchGate to Pune Cab Booking","Cab from ChurchGate to Pune"],
["ChurchGate to Pune Car Rental","ChurchGate to Pune Cab"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel from Churchgate to Pune via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic conditions ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Churchgate to Pune cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Churchgate to Pune cab service operates 24 hours a day. Whether you need an early morning ride, business travel, airport transfer, or late night ride, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Churchgate to Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Churchgate",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and nearby areas around Churchgate including Marine Drive, Nariman Point, and South Mumbai locations."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Churchgate to Pune cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Churchgate to Pune cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Churchgate to Pune with professional drivers and comfortable vehicles." },
  { question: "How far is Churchgate from Pune?", answer: "The road distance between Churchgate and Pune is approximately 155 km and the journey usually takes about 3 to 4 hours depending on traffic." },
  { question: "Is Churchgate to Pune cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Churchgate to Pune travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Churchgate to Pune?", answer: "Yes, we provide both one-way and round-trip cab services between Churchgate and Pune." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, railway stations, and residential areas across Churchgate and South Mumbai." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Churchgate to Pune cab services online or through phone booking." },
  { question: "Do you provide drop service to Pune Airport or railway station?", answer: "Yes, Velocity Cabs provides drop services to Pune Airport, railway stations, and major locations across Pune." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Karan Mehta",
    feedback:
      "My Churchgate to Pune trip with Velocity Cabs was extremely comfortable. The cab arrived on time, the driver was professional, and the journey was smooth throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Deshmukh",
    feedback:
      "I traveled from Churchgate to Pune and had a very pleasant experience. The vehicle was clean, the ride was safe, and everything was managed very efficiently.",
    rating: 5
  }
];
































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];








const churchgateToPuneJSON = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Church Gate to Pune Cab Service | Velocity Cabs",
  "description": "Book reliable Church Gate to Pune cab with Velocity Cabs. Available cars: Innova, Ertiga, Sedan. One-way, round trips, and airport transfers. Affordable fares with 24x7 service.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Church Gate, Mumbai, Maharashtra, India"
  },
  "serviceType": [
    "Church Gate to Pune Taxi",
    "One-way Cab Church Gate to Pune",
    "Round Trip Cab Service",
    "Outstation Taxi",
    "Airport Drop/Pickup"
  ],
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  }
};









  return (
    <div>
      
<Helmet>
  <title>Church Gate to Pune Cab Service | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book reliable Church Gate to Pune cab with Velocity Cabs. Innova, Ertiga, Sedan available for one-way, round trip, and airport transfers. Affordable fares & 24x7 service."
  />
  <script type="application/ld+json">
    {JSON.stringify(churchgateToPuneJSON)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/61.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Churchgatetopunecab;